import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * A component that allows the user to select a rank, represented by a number.
 * It provides functionality to increment the rank within a specified range (0-5)
 * and emits an event when the rank changes.
 *
 * @class RankSelectorComponent
 * @implements {OnInit}
 *
 * @author Tommaso Lazzaretti
 */
@Component({
  selector: 'app-rank-selector',
  templateUrl: './rank-selector.component.html',
  styleUrls: ['./rank-selector.component.scss']
})
export class RankSelectorComponent implements OnInit {
  @Input() valueRank: number | null = 0;
  @Input() defaultValue = 1;
  @Input() isDisabled = false;
  /** Il valore puo' restare non compilato: mostrato come "–", ciclo – → 1 … 5 → –, lo 0 non compare */
  @Input() allowEmpty = false;
  @Output() rankChange = new EventEmitter<number | null>();

  constructor(){}

  ngOnInit(): void {
    if (this.allowEmpty) {
      if (!this.valueRank) this.valueRank = null;
      return;
    }
    if (this.valueRank === null || this.valueRank === undefined)
      this.valueRank = this.defaultValue ? this.defaultValue : 0;
  }

  /**
   * Increments the rank value, cycling through a range of 1-5. If the rank value reaches 5,
   * it resets to the default value or 0 (or to empty when allowEmpty is set).
   *
   * @memberof RankSelectorComponent
   */
  incrementRank() {
    if (this.allowEmpty)
      this.valueRank = this.valueRank === 5 ? null : (this.valueRank ?? 0) + 1;
    else if (this.valueRank === 0)
      this.valueRank = 1;
    else
      this.valueRank = this.valueRank < 5 ? this.valueRank + 1 : this.defaultValue ? this.defaultValue : 0;

    this.rankChange.emit(this.valueRank);
  }

}
